import { Injectable } from '@angular/core';

import { ConnectionLostService } from '../../pages/secure/home/services/connection-lost.service';

@Injectable()
export class ConnectionGuard  {
  isConnected: boolean;

  constructor(private connectivityService: ConnectionLostService) {
    this.connectivityService.connectionStatus.subscribe(
      status => (this.isConnected = status)
    );
  }

  canActivateChild() {
    this.connectivityService.checkConnectivityStatus();
    return this.isConnected != null ? this.isConnected : false;
  }
}
